// match — exhaustive pattern match on tagged sums.
//
//   const describe = match<Extract.Error, string>({
//     "Extract.PasswordProtected": ()  => "PDF is password protected",
//     "Extract.InvalidInput":      (e) => `invalid input: ${e.reason}`,
//     "Extract.Failed":            (e) => `extract failed: ${e.reason}`,
//   });
//   describe(err);
//
// Every branch handler receives the fully-narrowed variant. TS
// requires the cases object to cover every tag in T — miss one
// and the call site errors. `_tag` reads happen inside this
// dispatcher exactly; consumers never grep `._tag` themselves.
export { match };
const match = (cases) => (t) => 
// The sanctioned dispatch seam. TS can't index the mapped
// `Cases` type with a generic `t._tag` (it widens to string
// inside the generic body), nor prove the selected handler
// accepts the full T rather than its own variant. Both casts
// are sound: at runtime t._tag picks the handler for t's exact
// variant. This is the isolated `matchable` site the dev-ts
// convention allows; no consumer reads `._tag` or casts itself.
cases[t._tag](t);
//# sourceMappingURL=match.js.map